import axios from 'axios';
import getAppSearchUrl from './appSearchUrl';

import { configureHttpHeaders, onSuccess, onError } from './apiHelpers';

const baseUrl = getAppSearchUrl();

function get(url, searchInputDetails) {
  let pathVariables = '';
  let separator = '';
  const sortObj = searchInputDetails.sort.map((obj) => {
    return {
      fieldId: obj.key,
      orderByProperty: obj.order ? 'ASC' : 'DESC',
    };
  });
  let sortKeyString = '';
  let sortOrderString = '';

  sortObj.forEach((element) => {
    sortKeyString += `orderByProperties=${element.fieldId}&`;
    sortOrderString += `direction=${element.orderByProperty}&`;
  });
  // eslint-disable-next-line guard-for-in, no-restricted-syntax, no-unused-vars
  for (const key in searchInputDetails) {
    if (key !== 'sort') {
      pathVariables = `${pathVariables + separator + key}=${searchInputDetails[key]}`;
      separator = '&';
    }
  }
  pathVariables = `${pathVariables}&${sortKeyString}${sortOrderString}`;
  return axios.get(`${baseUrl}${url}?${pathVariables}`).then(onSuccess).catch(onError);
}

export default {
  getAppDataAccordingToSearchFilters,
};

export function getAppDataAccordingToSearchFilters(filterObject, url) {
  configureHttpHeaders(axios);
  return get(`${url}`, filterObject);
}
